import { useState } from 'react';
import { useLingui } from '@lingui/react';
import { FilterButton, Menu } from '@pocketlaw/tetris';
import { parseISO } from 'date-fns';
import { DateRangeForm } from './DateRangeForm';
import { formatSelectedDateRange } from './formatSelectedDateRange';
import { useFilter } from '../useFilter';
export function DateRange(props) {
    const { name } = props;
    const filter = useFilter(name);
    const [open, setOpen] = useState(!filter.hasValue);
    const { i18n } = useLingui();
    const data = filter.value;
    const gte = (data === null || data === void 0 ? void 0 : data.gte) ? parseISO(data === null || data === void 0 ? void 0 : data.gte) : undefined;
    const lte = (data === null || data === void 0 ? void 0 : data.lte) ? parseISO(data === null || data === void 0 ? void 0 : data.lte) : undefined;
    const appearance = filter.isTouched ? 'draft' : 'default';
    const selectedValue = i18n._(formatSelectedDateRange(filter.value));
    const closeMenu = () => setOpen(false);
    const toggleMenu = () => setOpen(!open);
    return (<Menu.Root open={open} onClose={closeMenu} target={<FilterButton type="button" appearance={appearance} onClick={toggleMenu}>
          {selectedValue}
        </FilterButton>}>
      <DateRangeForm name={name} initialValue={{ gte, lte }} onClose={closeMenu}/>
    </Menu.Root>);
}
